
import * as handlebars_family from "../handlebars_family.js";

const TPL = handlebars_family.addTemplate("budget/modal_categorieslimit_item",{"1":function(container,depth0,helpers,partials,data) {
    var lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "data-fw-meta-id=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"metaId") : depth0), depth0))
    + "\"";
},"compiler":[8,">= 4.3.0"],"main":function(container,depth0,helpers,partials,data) {
    var stack1, lookupProperty = container.lookupProperty || function(parent, propertyName) {
        if (Object.prototype.hasOwnProperty.call(parent, propertyName)) {
          return parent[propertyName];
        }
        return undefined
    };

  return "<flexrow draggable=\"true\" class=\"hover-controller\" style=\"border-radius:8px;var(--border);margin-top:2px;padding:0 0 0 16px\" "
    + ((stack1 = lookupProperty(helpers,"if").call(depth0 != null ? depth0 : (container.nullContext || {}),(depth0 != null ? lookupProperty(depth0,"metaId") : depth0),{"name":"if","hash":{},"fn":container.program(1, data, 0),"inverse":container.noop,"data":data,"loc":{"start":{"line":1,"column":125},"end":{"line":1,"column":176}}})) != null ? stack1 : "")
    + "><emoji>"
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"category") : depth0)) != null ? lookupProperty(stack1,"emoji") : stack1), depth0))
    + "</emoji><input readonly name=\"name\" style=\"flex:1;border-color:transparent;margin-top:0;font-weight:500;color:unset\" value=\""
    + container.escapeExpression(container.lambda(((stack1 = (depth0 != null ? lookupProperty(depth0,"category") : depth0)) != null ? lookupProperty(stack1,"name") : stack1), depth0))
    + "\"><input type=\"amount\" value=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"limit") : depth0), depth0))
    + "\" style=\"flex:0.5;border:none;margin-top:0;text-align:right;opacity:0.87\" data-currency-code=\""
    + container.escapeExpression(container.lambda((depth0 != null ? lookupProperty(depth0,"currencyCode") : depth0), depth0))
    + "\"></flexrow>";
},"useData":true});
export default TPL;